import { motion } from 'framer-motion'

interface FlyingImageAnimationProps {
  isVisible: boolean
  sourcePosition: {
    x: number
    y: number
  }
  targetPosition: {
    x: number
    y: number
  }
  imageUrl: string
}

export const FlyingImageAnimation = ({
  isVisible,
  sourcePosition,
  targetPosition,
  imageUrl,
}: FlyingImageAnimationProps) => {
  if (!isVisible) return null

  return (
    <motion.div
      initial={{
        scale: 1,
        opacity: 1,
        x: 0,
        y: 0,
        width: '150px',
        height: '150px',
      }}
      animate={{
        scale: 0.3,
        x: targetPosition.x - sourcePosition.x,
        y: targetPosition.y - sourcePosition.y,
        opacity: 0,
      }}
      transition={{
        duration: 0.5,
        ease: 'easeOut',
      }}
      className="fixed pointer-events-none z-50"
      style={{
        left: sourcePosition.x,
        top: sourcePosition.y,
      }}
    >
      <div className="w-full h-full bg-white rounded-lg overflow-hidden shadow-lg">
        <img
          src={imageUrl}
          alt="Selected"
          className="w-full h-full object-cover"
        />
      </div>
    </motion.div>
  )
}
